
import { useTranslation } from "react-i18next";
import { PageContainer } from "@/components/PageContainer";
import { PageHeader } from "@/components/PageHeader";

export default function Notifications() {
  const { t } = useTranslation();
  
  return (
    <PageContainer>
      <PageHeader 
        title={t("menu.notifications")} 
        subtitle={t("notifications.subtitle")}
      />
      {/* Content will be added in the future */}
    </PageContainer>
  );
}
